import { useState } from 'react';
import { Button } from '@/components/ui/Button';
import { THEME_LABELS } from '@/lib/company-qualification';
import { EvidenceButton, EvidenceLines, type Lines } from '@/components/profile/restitution/Evidence';
import { ThemeVisualView } from '@/components/profile/restitution/RestitutionVisuals';
import type { QualificationThemeKey } from '@shared/types/company-qualification';
import type { ThemePage } from '@shared/types/company-restitution';

interface Props {
  theme: QualificationThemeKey;
  page: ThemePage;
  lines: Lines;
  stale: boolean;
  onDeepen: () => void;
  /** Opens the sheet on this theme: every line, editable. */
  onLines: () => void;
}

/** Level 2: one theme — a title that concludes, the visual that proves it, what it changes. */
export const ThemePageView = ({ theme, page, lines, stale, onDeepen, onLines }: Props) => {
  const [open, setOpen] = useState(false);
  return (
    <section className="rounded-xl border border-domino-cardBorder bg-domino-warm px-6 py-5 sm:px-8">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-xs font-semibold uppercase tracking-wide text-domino-inkSoft">{THEME_LABELS[theme].label}</p>
        <div className="flex items-center gap-3 text-sm">
          {stale && <span className="text-xs text-amber-800">Le thème a changé depuis.</span>}
          <button type="button" onClick={onLines} className="text-domino-inkSoft hover:text-domino-ink hover:underline">Toutes les lignes</button>
          <Button variant="ghost" size="sm" onClick={onDeepen}>Approfondir</Button>
        </div>
      </div>
      <div className="mt-1 flex items-start justify-between gap-3">
        <h3 className="font-display text-xl leading-snug text-domino-ink">{page.title}</h3>
        <span className="mt-1.5 shrink-0"><EvidenceButton ids={page.evidence} lines={lines} open={open} onToggle={() => setOpen(!open)} /></span>
      </div>
      {open && <EvidenceLines ids={page.evidence} lines={lines} className="mt-2" />}
      <div className="mt-4"><ThemeVisualView theme={theme} visual={page.visual} lines={lines} /></div>
      {page.takeaway && (
        <p className="mt-5 border-l-2 border-domino-aubergine pl-3 text-sm leading-6 text-domino-ink">{page.takeaway}</p>
      )}
    </section>
  );
};
